<template>
    <v-app>
        <v-content v-if="oldVersion">
            <v-container class="cross-header">
                <a
                    class="cross-header__link"
                    :href="'/osago/new/' + uuid"
                >
                    Назад
                </a>
                <h1 class="cross-header__title">Оформление полиса</h1>
            </v-container>
            <v-form ref="approve" v-model="valid" class="approve-form">
                <v-container class="cross-main">
                    <h2 class="cross-main__title">Оплата кросс продукта Авто 2 в 1</h2>
                    <v-layout column row>
                        <v-layout align-center row wrap>
                            <v-flex md6 xs12 class="pay-and-refresh">
                                <h3 class="cross-main__subtitle">Ссылка на оплату</h3>
                                <a class="flex refresh-link" v-on:click="refreshLink">Обновить ссылку</a>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <v-layout column row pb-5>
                        <v-layout
                            class="url-wrapper"
                            align-center row wrap>
                            <v-flex md6 xs12 class="url">
                                <v-layout row>
                                    <v-flex class="nowrap-text" v-if="crossLink">
                                        <span class="url__text">{{ crossLink }}</span>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-flex pl-2 v-if="crossLink">
                                        <v-btn
                                            class="url__copy"
                                            flat icon color="#828282"
                                            v-clipboard="crossLink"
                                            onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                                            :disabled="crossPayed == true || checkedStatus"
                                        >
                                            <v-icon>content_copy</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-btn
                                class="submit-button block"
                                @click="payCross"
                                :disabled="crossPayed == true || checkedStatus"
                            >
                                Оплатить
                            </v-btn>
                            <v-btn
                                class="check-button block"
                                @click="checkStatus"
                            >
                                Проверить статус
                            </v-btn>
                            <span
                                v-if="!crossPayed && !checkedStatus"
                                class="cross-main__error pb-3"
                            >
                                Оплата ОСАГО станет доступна после оплаты кросс продукта.
                            </span>
                            <span
                                v-if="crossPayed || checkedStatus"
                                class="cross-main__success pb-3"
                            >
                                Оплата Авто 2 в 1 успешна. Оплатите ОСАГО ниже на странице.
                            </span>
                            <span
                                v-if="errorPaymentCross"
                                class="cross-main__error pb-3"
                            >
                                Оплата Авто 2 в 1 не прошла. Повторите оплату.
                            </span>
                        </v-layout>
                        <v-layout pb-5>
                            <v-flex>
                                <v-checkbox
                                    v-model="crossApproved"
                                    :rules="[rules.approveCross]"
                                    validate-on-blur
                                >
                                    <template v-slot:label>
                                        <div>
                                            Я ознакомлен с <a href="/storage/app/manage_cross/auto_policy_example.pdf" target="_blank">примером страхового полиса</a>
                                            и <a href="/storage/app/manage_cross/kid_auto.rar" target="_blank">КИД</a>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-layout
                            class="cost-wrapper"
                            align-center row wrap>
                            <v-flex lg3 xs12 v-if="companyLogo">
                                <img :src="companyLogo" class="data-logo" />
    <!--                            <img class="data-logo" src="/img/mortgage/absolute.png" alt="absolute" />-->
                            </v-flex>
                            <v-flex lg3 md3 sm5 xs12 v-if="startDate">
                                <span class="data-title">Начало действия</span>
                                <span class="data-param">{{ startDate }}</span>
                            </v-flex>
                            <v-flex lg3 md3 sm5 xs12 v-if="crossPremium">
                                <span class="data-title">Cтоимость, ₽</span>
                                <span class="data-param">{{ crossPremium }} ₽</span>
                            </v-flex>
                            <v-flex lg2 md2 sm5 xs12 v-if="period">
                                <span class="data-title">Срок действия</span>
                                <span class="data-param">{{ period }} мес</span>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <h3 class="cross-main__subtitle">Образцы документов</h3>
                    <v-layout pb-5 row wrap>
                        <v-flex lg4 xs12 pb-2>
                            <a href="/storage/app/manage_cross/auto_policy_example.pdf" target="_blank">Образец полиса Авто 2 в 1</a>
                        </v-flex>
                        <v-flex lg4 xs12 pb-2>
                            <a href="/storage/app/manage_cross/pull_cross_insurance_conditions.docx" target="_blank">Условия страхования Авто 2 в 1</a>
                        </v-flex>
                        <v-flex lg4 xs12 pb-2>
                            <a href="/storage/app/manage_cross/kid_auto.rar" target="_blank">КИД к полису Авто 2 в 1</a>
                        </v-flex>
                    </v-layout>
                    <h3 class="cross-main__subtitle">Отправить ссылку на оплату клиенту</h3>
                    <v-layout row wrap>
                        <v-flex md4 sm6>
                            <v-checkbox
                                label="На e-mail"
                                v-model="crossEmailChecked"
                            />
                            <v-text-field
                                class="text-input"
                                v-if="crossEmailChecked"
                                label="E-mail клиента"
                                v-model="email"
                                validate-on-blur
                                :disabled="!crossEmailChecked"
                            />
                            <v-text-field
                                v-if="!crossEmailChecked"
                                :value="email"
                                class="text-input"
                                label="E-mail клиента"
                                v-model="email"
                                :disabled="true"
                            />
                        </v-flex>
                        <v-flex md4 sm6>
                            <v-checkbox
                                label="На телефон"
                                v-model="crossPhoneChecked"
                            />
                            <v-text-field
                                class="text-input"
                                v-if="crossPhoneChecked"
                                v-model="maskedPhone"
                                v-mask="'+7 ### ### ## ##'"
                                label="Телефон клиента"
                                :disabled="!crossPhoneChecked"
                            />
                            <v-text-field
                                class="text-input"
                                v-if="!crossPhoneChecked"
                                label="Телефон клиента"
                                v-model="maskedPhone"
                                v-mask="'+7 ### ### ## ##'"
                                :disabled="true"
                            />
                        </v-flex>
                        <v-flex md4 sm12
                                class="button"
                        >
                            <v-btn
                                class="send-button block"
                                @click="crossSendLink"
                            >
                                Отправить
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-container class="cross-main">
                <h2 class="cross-main__title">Оплата Осаго</h2>
                <h3 class="cross-main__subtitle">Ссылка на оплату</h3>
                <v-layout column row pb-5>
                    <v-layout
                        class="url-wrapper"
                        align-center row wrap pb-3>
                        <v-flex md6 xs12 class="url">
                            <v-layout row>
                                <v-flex class="nowrap-text" v-if="link">
                                    <span class="url__text">{{ link }}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex pl-2 v-if="link">
                                    <v-btn
                                        class="url__copy"
                                        flat icon color="#828282"
                                        v-clipboard="link"
                                        :disabled="!crossPayed && !checkedStatus"
                                        onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                                    >
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-btn
                            class="submit-button block"
                            @click="payOsago"
                            :disabled="!crossPayed && !checkedStatus"
                        >
                            Оплатить
                        </v-btn>
                        <v-btn
                            class="check-button block"
                            v-if="errorPaymentOsago"
                            @click="toManage"
                            :loading="updateLoading"
                        >
                            Обновить ссылку
                        </v-btn>
                        <span
                            v-if="!crossPayed && !checkedStatus"
                            class="cross-main__error pb-3"
                        >
                            Оплата полиса ОСАГО возможна только после оплаты кросс-продукта
                        </span>
                        <span
                            v-if="errorPaymentOsago"
                            class="cross-main__error pb-3"
                        >
                            Оплата полиса ОСАГО не прошла. Если форма оплаты не появилась - попробуйте обновить
                            ссылку на оплату. Для этого нажмите на кнопку “Обновить ссылку“
                        </span>
                    </v-layout>
                    <v-layout
                        class="cost-wrapper"
                        align-center row wrap>
                        <v-flex lg3 xs12 v-if="companyLogo">
                            <img :src="companyLogo" class="data-logo" />
<!--                            <img class="data-logo" src="/img/mortgage/alfa.png" alt="alfa" />-->
                        </v-flex>
                        <v-flex lg3 md3 sm5 xs12 v-if="startDate">
                            <span class="data-title">Начало действия</span>
                            <br>
                            <span class="data-param">{{ startDate }}</span>
                        </v-flex>
                        <v-flex lg3 md3 sm5 xs12 v-if="premium && crossPremium">
                            <span class="data-title">Cтоимость, ₽</span>
                            <br>
                            <span class="data-param">{{ (premium - crossPremium).toFixed(2) }} ₽</span>
                        </v-flex>
                        <v-flex lg2 md2 sm5 xs12 v-if="period">
                            <span class="data-title">Срок действия</span>
                            <br>
                            <span class="data-param">{{ period }} мес</span>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <h3 class="cross-main__subtitle">Образцы документов</h3>
                <v-layout pb-5 row wrap>
                    <v-flex lg3>
                        <a href="/storage/app/manage_cross/sample_osago_21vek.pdf" target="_blank">Образец полиса Осаго</a>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle">Отправить ссылку на оплату клиенту</h3>
                <v-layout row wrap pb-5>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На e-mail"
                            v-model="emailChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="emailChecked"
                            label="E-mail клиента"
                            v-model="email"
                            validate-on-blur
                            :disabled="!emailChecked"
                        />
                        <v-text-field
                            v-if="!emailChecked"
                            :value="email"
                            class="text-input"
                            label="E-mail клиента"
                            v-model="email"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На телефон"
                            v-model="phoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="phoneChecked"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            label="Телефон клиента"
                            :disabled="!phoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="!phoneChecked"
                            label="Телефон клиента"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm12
                            class="button"
                    >
                        <v-btn
                            class="send-button block"
                            @click="sendLink"
                        >
                            Отправить
                        </v-btn>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle">Кросс-продукт</h3>
                <v-layout row wrap>
                    <v-flex lg4>
                        <v-text-field
                            class="text-input"
                            label="Страховая компания"
                            value="Двадцать первый век"
                            disabled
                        />
                    </v-flex>
                    <v-flex lg4>
                        <v-text-field
                            class="text-input"
                            label="Тип полиса"
                            value="Авто 2 в 1"
                            disabled
                        />
                    </v-flex>
                    <v-flex lg4>
                        <v-text-field
                            class="text-input"
                            label="Объект страхования"
                            v-if="markModel"
                            :value="markModel"
                            disabled
                        />
                    </v-flex>
                    <v-flex lg4>
                        <v-text-field
                            class="text-input"
                            label="Страховая сумма"
                            v-if="premium"
                            :value="premium + ' ₽'"
                            disabled
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-content v-if="!oldVersion">
            <v-container class="cross-header">
                <a
                    class="cross-header__link"
                    :href="'/osago/new/' + uuid"
                >
                    Назад
                </a>
                <h1 class="cross-header__title">Оформление полиса</h1>
            </v-container>
            <v-container class="cross-main grid-list-lg" v-if="!isOsagoCrossOneLink">
                <h2 class="cross-main__title">Оплата Осаго</h2>
                <h3 class="cross-main__subtitle">Ссылка на оплату</h3>
                <v-layout column row pb-5>
                    <v-layout
                        class="url-wrapper"
                        align-center row wrap pb-3>
                        <v-flex md6 xs12 class="url">
                            <v-layout row>
                                <v-flex class="nowrap-text" v-if="link">
                                    <span class="url__text">{{ link }}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex pl-2 v-if="link">
                                    <v-btn
                                        class="url__copy"
                                        flat icon color="#828282"
                                        v-clipboard="link"
                                        :disabled="isOsagoCopyButtonDisabled"
                                        onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                                    >
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-btn
                            class="submit-button block"
                            @click="payOsago"
                            :disabled="isOsagoPayButtonDisabled"
                        >
                            Оплатить
                        </v-btn>
                        <v-btn
                            class="check-button block"
                            @click="osagoCheckStatus"
                        >
                            Проверить статус
                        </v-btn>
                        <v-btn
                            class="check-button block"
                            v-if="errorPaymentOsago"
                            @click="toManage"
                            :loading="updateLoading"
                        >
                            Обновить ссылку
                        </v-btn>
                        <span
                            v-if="osagoPayed || osagoCheckedStatus"
                            class="cross-main__success pb-3"
                        >
                            Оплата полиса ОСАГО прошла успешно!
                        </span>
                        <span
                            v-if="crossRequiredPayment && !crossPayed && !checkedStatus"
                            class="cross-main__error pb-3"
                        >
                            Оплата полиса ОСАГО возможна только после оплаты кросс-продукта
                        </span>
                        <span
                            v-if="errorPaymentOsago"
                            class="cross-main__error pb-3"
                        >
                            Оплата полиса ОСАГО не прошла. Если форма оплаты не появилась - попробуйте обновить
                            ссылку на оплату. Для этого нажмите на кнопку “Обновить ссылку“
                        </span>
                    </v-layout>
                    <v-layout
                        class="cost-wrapper"
                        align-center row wrap>
                        <v-flex lg3 xs12 v-if="companyLogo">
                            <img :src="companyLogo" class="data-logo" />
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="startDate">
                            <span class="data-title">Начало действия</span>
                            <br>
                            <span class="data-param">{{ startDate }}</span>
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="premium">
                            <span class="data-title">Cтоимость, ₽</span>
                            <br>
                            <span class="data-param">{{ premium + ' ₽' }}</span>
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="commission">
                            <span class="data-title">Страховая премия</span>
                            <br>
                            <span class="data-param">{{ parseFloat(commission).toFixed(2) + ' ₽' }}</span>
                        </v-flex>
                        <v-flex lg2 md2 sm5 xs12 v-if="period">
                            <span class="data-title">Срок действия</span>
                            <br>
                            <span class="data-param">{{ period }} мес</span>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <h3 class="cross-main__subtitle" v-if="oldVersion || crossSelected || sample || insurance_conditions">Образцы документов</h3>
                <v-layout pb-5 row wrap>
                    <v-flex lg3 xs12 v-if="oldVersion">
                        <a href="/storage/app/manage_cross/sample_osago_21vek.pdf" target="_blank">Образец полиса Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="sample">
                        <a :href="`/` + sample" target="_blank">Образец полиса Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="insurance_conditions">
                        <a :href="`/` + insurance_conditions" target="_blank">Условия страхования Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.samples">
                        <a :href="`/` + crossSelected.samples.policy" target="_blank">Образец полиса Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.insurance_conditions">
                        <a :href= "`/` + crossSelected.insurance_conditions.policy" target="_blank">Условия страхования Осаго</a>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle">Отправить ссылку на оплату клиенту</h3>
                <v-layout row wrap pb-5>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На e-mail"
                            v-model="emailChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="emailChecked"
                            label="E-mail клиента"
                            v-model="email"
                            validate-on-blur
                            :disabled="!emailChecked"
                        />
                        <v-text-field
                            v-if="!emailChecked"
                            :value="email"
                            class="text-input"
                            label="E-mail клиента"
                            v-model="email"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На телефон"
                            v-model="phoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="phoneChecked"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            label="Телефон клиента"
                            :disabled="!phoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="!phoneChecked"
                            label="Телефон клиента"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm12
                            class="button"
                    >
                        <v-btn
                            class="send-button block"
                            @click="sendLink"
                            :disabled="isOsagoSendLinkDisabled"
                        >
                            Отправить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container class="cross-main grid-list-lg" v-if="isOsagoCrossOneLink">
                <h2 class="cross-main__title">{{ 'Оплата ОСАГО и кросс-продукта ' + crossSelected.name }}</h2>
                <h3 class="cross-main__subtitle">Ссылка на оплату</h3>
                <v-layout column row pb-5>
                    <v-layout
                        class="url-wrapper"
                        align-center row wrap pb-3>
                        <v-flex md6 xs12 class="url">
                            <v-layout row>
                                <v-flex class="nowrap-text" v-if="link">
                                    <span class="url__text">{{ link }}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex pl-2 v-if="link">
                                    <v-btn
                                        class="url__copy"
                                        flat icon color="#828282"
                                        v-clipboard="link"
                                        :disabled="isOsagoCopyButtonDisabled"
                                        onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                                    >
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-btn
                            class="submit-button block"
                            @click="payOsago"
                            :disabled="isOsagoPayButtonDisabled"
                        >
                            Оплатить
                        </v-btn>
                        <v-btn
                            class="check-button block"
                            @click="osagoCheckStatus"
                        >
                            Проверить статус
                        </v-btn>
                        <v-btn
                            class="check-button block"
                            v-if="errorPaymentOsago"
                            @click="toManage"
                            :loading="updateLoading"
                        >
                            Обновить ссылку
                        </v-btn>
                        <span
                            v-if="osagoPayed || osagoCheckedStatus"
                            class="cross-main__success pb-3"
                        >
                            Оплата полиса ОСАГО и кросс-продукта прошла успешно!
                        </span>
                        <span
                            v-if="errorPaymentOsago"
                            class="cross-main__error pb-3"
                        >
                            Оплата полиса ОСАГО не прошла. Если форма оплаты не появилась - попробуйте обновить
                            ссылку на оплату. Для этого нажмите на кнопку “Обновить ссылку“
                        </span>
                    </v-layout>
                    <v-layout
                        class="" row wrap>
                        <v-flex lg4 xs12 class="logos text-center" v-if="companyLogo">
                            <div>
                                <img :src="companyLogo" class="data-logos" />
                                <span class="text-center">ОСАГО</span>
                            </div>
                            <span class="text-center">+</span>
                            <div>
                                <img :src="getImageUrl(crossSelected.companyLogotype)" class="data-logos" />
                                <span class="text-center">{{ crossSelected.name }}</span>
                            </div>
                        </v-flex>
                        <v-flex lg3 md3 sm5 xs12 v-if="premium && crossSelected.product.price">
                            <span class="data-title">Cтоимость, ₽</span>
                            <br>
                            <span class="data-param">{{ (parseFloat(premium) + crossSelected.product.price).toFixed(2) + ' ₽' }}</span>
                            <v-layout row wrap>
                                <v-flex class="no-wrap">
                                <span class="data-cross-param">
                                    {{ parseFloat(premium).toFixed(2) + ' ₽'}}
                                </span>
                                    <span class="data-cross-title">ОСАГО</span>
                                </v-flex>
                                <v-flex class="no-wrap">
                                <span class="data-cross-param">
                                    {{ parseFloat(crossSelected.product.price).toFixed(2) + ' ₽'}}
                                </span>
                                    <span class="data-cross-title">{{ crossSelected.name }}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex lg3 md3 sm5 xs12 v-if="commission && crossSelected.product.commission">
                            <span class="data-title">Страховая премия, ₽</span>
                            <br>
                            <span class="data-param"
                            >
                                {{ parseFloat(commission + crossSelected.product.commission).toFixed(2) + ' ₽' }}
                            </span>
                            <v-layout row wrap>
                                <v-flex class="no-wrap">
                                    <span class="data-cross-param">
                                        {{ parseFloat(commission).toFixed(2) + ' ₽'}}
                                    </span>
                                    <span class="data-cross-title">ОСАГО</span>
                                </v-flex>
                                <v-flex class="no-wrap">
                                    <span class="data-cross-param">
                                        {{ parseFloat(crossSelected.product.commission).toFixed(2) + ' ₽'}}
                                    </span>
                                    <span class="data-cross-title">{{ crossSelected.name }}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="startDate || period">
                            <span class="data-title">Начало действия</span>
                            <br>
                            <span class="data-param" v-if="startDate">{{ startDate }}</span>
                            <span class="data-title">Срок действия</span>
                            <br>
                            <span class="data-param" v-if="period">{{ period }} мес</span>
                        </v-flex>
<!--                        <v-flex lg2 v-if="period">

                        </v-flex>-->
                    </v-layout>
                </v-layout>
                <h3 class="cross-main__subtitle">Страховые риски</h3>
                <v-layout pb-5 row wrap>
                    <v-flex class="green-mark" lg4 pb-2 xs12
                            v-for="(item, index) in filteredInfo" :key="index"
                    >
                        {{ item.title }}
                        <p>{{ item.value}}</p>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle" v-if="oldVersion || crossSelected">Образцы документов</h3>
                <v-layout pb-5 row wrap>
                    <v-flex lg3 v-if="oldVersion">
                        <a href="/storage/app/manage_cross/sample_osago_21vek.pdf" target="_blank">Образец полиса Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.samples">
                        <a :href="`/` + crossSelected.samples.policy" target="_blank">Образец полиса Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.samples">
                        <a :href="`/` + crossSelected.samples.cross" target="_blank">{{ 'Образец полиса ' + crossSelected.name }}</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.insurance_conditions">
                        <a :href= "`/` + crossSelected.insurance_conditions.policy" target="_blank">Условия страхования Осаго</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.insurance_conditions">
                        <a :href= "`/` + crossSelected.insurance_conditions.cross" target="_blank">{{ 'Условия страхования ' + crossSelected.name }}</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.kid_example">
                        <a :href= "`/` + crossSelected.kid_example" target="_blank">{{ 'КИД ' + crossSelected.name }}</a>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle">Отправить ссылку на оплату клиенту</h3>
                <v-layout row wrap pb-5>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На e-mail"
                            v-model="emailChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="emailChecked"
                            label="E-mail клиента"
                            v-model="email"
                            validate-on-blur
                            :disabled="!emailChecked"
                        />
                        <v-text-field
                            v-if="!emailChecked"
                            :value="email"
                            class="text-input"
                            label="E-mail клиента"
                            v-model="email"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На телефон"
                            v-model="phoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="phoneChecked"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            label="Телефон клиента"
                            :disabled="!phoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="!phoneChecked"
                            label="Телефон клиента"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm12
                            class="button"
                    >
                        <v-btn
                            class="send-button block"
                            @click="sendLink"
                            :disabled="isOsagoSendLinkDisabled"
                        >
                            Отправить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container
                class="cross-main grid-list-lg"
                v-if="!isCrossWasSelectedPrevious"
            >
                <v-layout column mb-5>
                    <h2 class="cross-main__title">C полисом ОСАГО обычно оформляют</h2>
                    <osago-companies-list-cross
                        :crosses="crosses"
                        :parentKey="parentKey"
                        :panel="panel"
                        :selectedCrossId="selectedCrossId"
                        @selectCrossId="selectCrossId"
                    >
                    </osago-companies-list-cross>
                </v-layout>
                <v-btn
                    class="submit-button block"
                    @click="userSelectCrossProduct"
                    v-if="selectedCrossId"
                    :loading="isConfirmBtnLoading"
                >
                    Подтвердить выбор
                </v-btn>
            </v-container>
            <v-container
                class="cross-main grid-list-lg"
                v-if="isCrossWasSelectedPrevious && !isOsagoCrossOneLink"
            >
                <h2 class="cross-main__title">{{ 'Оплата кросс-продукта ' + crossSelected.name }}</h2>
                <h3 class="cross-main__subtitle">Ссылка на оплату</h3>
                <v-layout column row pb-5>
                    <v-layout
                        class="url-wrapper"
                        align-center row wrap pb-3>
                        <v-flex md6 xs12 class="url">
                            <v-layout row>
                                <v-flex class="nowrap-text" v-if="crossSelected.link">
                                    <span class="url__text">{{ crossSelected.link }}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex pl-2 v-if="crossSelected.link">
                                    <v-btn
                                        class="url__copy"
                                        flat icon color="#828282"
                                        v-clipboard="crossSelected.link"
                                        onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                                        :disabled="isCrossCopyButtonDisabled"
                                    >
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-btn
                            class="submit-button block"
                            @click="payCross"
                            :disabled="isCrossPayButtonDisabled"
                        >
                            Оплатить
                        </v-btn>
                        <v-btn
                            class="check-button block"
                            @click="crossCheckStatus"
                        >
                            Проверить статус
                        </v-btn>
                        <span
                            v-if="crossPayed || checkedStatus"
                            class="cross-main__success pb-3"
                        >
                            {{ 'Оплата ' + crossSelected.name + ' успешна.' }}
                        </span>
                        <div
                            v-if="errorPaymentCross"
                            class="cross-main__second-error pb-3"
                        >
                            {{ 'Выбранный вами полис ' + crossSelected.name + ' оформить не удалось.' }}
                            <br>
                            {{ 'Ошибка: ' + errorPaymentCross }}
                        </div>
                    </v-layout>
                    <v-layout
                        class="cost-wrapper"
                        align-center row wrap>
                        <v-flex lg3 xs12 v-if="crossSelected.companyLogotype">
                            <img :src="getImageUrl(crossSelected.companyLogotype)" class="data-logo" />
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="startDate">
                            <span class="data-title">Начало действия</span>
                            <br>
                            <span class="data-param">{{ startDate }}</span>
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="crossSelected.product.price">
                            <span class="data-title">Cтоимость, ₽</span>
                            <br>
                            <span class="data-param">{{ crossSelected.product.price + ' ₽' }}</span>
                        </v-flex>
                        <v-flex lg2 md3 sm5 xs12 v-if="crossSelected.product.commission">
                            <span class="data-title">Страховая премия</span>
                            <br>
                            <span class="data-param">{{ crossSelected.product.commission + ' ₽' }}</span>
                        </v-flex>
                        <v-flex lg2 md2 sm5 xs12 v-if="period">
                            <span class="data-title">Срок действия</span>
                            <br>
                            <span class="data-param">{{ period }} мес</span>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <h3 class="cross-main__subtitle">Страховые риски</h3>
                <v-layout pb-5 row wrap>
                    <v-flex class="green-mark" lg4 pb-2 xs12
                            v-for="(item, index) in filteredInfo" :key="index"
                    >
                        {{ item.title }}
                        <p>{{ item.value}}</p>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle" v-if="oldVersion || crossSelected">{{ 'Образцы документов ' + crossSelected.name }}</h3>
                <v-layout pb-5 row wrap>
                    <v-flex lg3 xs12 v-if="crossSelected.samples">
                        <a :href="`/` + crossSelected.samples.cross" target="_blank">{{ 'Образец полиса ' + crossSelected.name }}</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.insurance_conditions">
                        <a :href= "`/` + crossSelected.insurance_conditions.cross" target="_blank">{{ 'Условия страхования ' + crossSelected.name }}</a>
                    </v-flex>
                    <v-flex lg3 xs12 v-if="crossSelected.kid_example">
                        <a :href= "`/` + crossSelected.kid_example" target="_blank">{{ 'КИД ' + crossSelected.name }}</a>
                    </v-flex>
                    <v-flex lg4 xs12 pb-2 v-if="oldVersion">
                        <a href="/storage/app/manage_cross/auto_policy_example.pdf" target="_blank">Образец полиса Авто 2 в 1</a>
                    </v-flex>
                    <v-flex lg4 xs12 pb-2 v-if="oldVersion">
                        <a href="/storage/app/manage_cross/pull_cross_insurance_conditions.docx" target="_blank">Условия страхования Авто 2 в 1</a>
                    </v-flex>
                    <v-flex lg4 xs12 pb-2 v-if="oldVersion">
                        <a href="/storage/app/manage_cross/kid_auto.rar" target="_blank">КИД к полису Авто 2 в 1</a>
                    </v-flex>
                </v-layout>
                <h3 class="cross-main__subtitle">Отправить ссылку на оплату клиенту</h3>
                <v-layout row wrap>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На e-mail"
                            v-model="crossEmailChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="crossEmailChecked"
                            label="E-mail клиента"
                            v-model="email"
                            validate-on-blur
                            :disabled="!crossEmailChecked"
                        />
                        <v-text-field
                            v-if="!crossEmailChecked"
                            :value="email"
                            class="text-input"
                            label="E-mail клиента"
                            v-model="email"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm6>
                        <v-checkbox
                            label="На телефон"
                            v-model="crossPhoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="crossPhoneChecked"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            label="Телефон клиента"
                            :disabled="!crossPhoneChecked"
                        />
                        <v-text-field
                            class="text-input"
                            v-if="!crossPhoneChecked"
                            label="Телефон клиента"
                            v-model="maskedPhone"
                            v-mask="'+7 ### ### ## ##'"
                            :disabled="true"
                        />
                    </v-flex>
                    <v-flex md4 sm12
                            class="button"
                    >
                        <v-btn
                            class="send-button block"
                            @click="crossSendLink"
                            :disabled="isCrossSendLinkDisabled"
                        >
                            Отправить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: "ManageCrossLink",
    props: [
        'link',
        'hashId',
        'crossAlias',
        'markModel',
        'companyLogo',
        'premium',
        'startDate',
        'period',
        'crossRequiredPayment',
        'crossDoublePay',
        'crossLink',
        'crossPremium',
        'crossPayed',
        'errorPaymentOsago',
        'errorPaymentCross',
        'errorService',
        'email',
        'phone',
        'uuid',
        'type',
        'cross',
        'osagoPayed',
        'commission',
        'crossSelected',
        'crosses',
        'sample',
        'insurance_conditions',
    ],
    data: () => ({
        crossEmailChecked: false,
        crossPhoneChecked: false,
        maskedCrossPhone: null,
        emailChecked: false,
        phoneChecked: false,
        maskedPhone: null,
        checkedStatus: false,
        updateLoading: false,
        valid: true,
        crossApproved: false,
        rules: {
            approveCross: v => v || 'Необходимо подтвердить утверждение',
        },
        // Ниже всё то, что необходимо для задачи с кросс-продуктами
        oldVersion: false,
        panel: [1],
        parentKey: 1,
        selectedCrossId: null,
        osagoCheckedStatus: false,
        isCrossCheckedStatus: false,
        isOsagoCrossOneLink: false,
        isCrossWasSelectedPrevious: false,
        isConfirmBtnLoading: false,
    }),
    created() {
        if (this.errorService) {
            PNotify.error(this.errorService);
            console.log(this.errorService);
        };
        this.maskedPhone = '+' + this.phone;

        // Ниже всё то, что необходимо для задачи с кросс-продуктами

        if (this.crossSelected) {
            this.crossSelected = JSON.parse(this.crossSelected);
        }

        this.oldVersion = true;


        if (this.crossSelected) {
            this.isCrossWasSelectedPrevious = true;

            if (this.crossSelected) {
                (this.crossSelected.link == null ? this.isOsagoCrossOneLink = true : this.isOsagoCrossOneLink = false);
            }
        }

    },
    methods: {
        payCross() {
            if (this.oldVersion) {
                if (this.$refs.approve.validate()) {
                    window.open(this.crossLink, '_self');
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Необходимо подтвердить утверждение')
                        this.goToFirstError()
                    });
                }
            } else {
                window.open(this.crossLink, '_self');
            }
        },
        payOsago() {
            window.open(this.link, '_self');
        },
        toManage() {
            this.updateLoading = true;
            window.open('/manage-cross/' + this.hashId, '_self');
        },
        crossSendLink() {
            if (this.crossPayed == true || this.checkedStatus) {
                return;
            }
            if (!this.crossEmailChecked && !this.crossPhoneChecked) {
                PNotify.info('Невозможно отправить ссылку');
                return;
            }
            const data = {
                'sendEmail': this.crossEmailChecked,
                'email': this.email,
                'sendSms': this.crossPhoneChecked,
                'phone': this.unmaskPhone(this.maskedPhone),
                'type': this.cross,
                'crossLink': this.crossLink,
                'crossPremium': this.crossPremium
            };
            axios.post('/send-link/' + this.hashId, data)
                .then(response => {
                    const success = response.data && response.data.status && response.data.status === 'success';
                    let sent = false;
                    if (success) {
                        sent = response.data.emailSent || response.data.smsSent;
                        if (sent) {
                            PNotify.success('Ссылка была отправлена');
                        }
                    }
                    if (!success || !sent) {
                        PNotify.info('Не удалось отправить уведомление');
                        console.log(response);
                    }
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Не удалось отправить уведомление');
                })
        },
        sendLink() {
            if (!this.isOsagoCrossOneLink) {
                if (this.crossRequiredPayment) {
                    if (!this.crossPayed && !this.checkedStatus) {
                        return;
                    }
                }
            }

            if (!this.emailChecked && !this.phoneChecked) {
                PNotify.info('Невозможно отправить ссылку');
                return;
            }
            const data = {
                'sendEmail': this.emailChecked,
                'email': this.email,
                'sendSms': this.phoneChecked,
                'phone': this.unmaskPhone(this.maskedPhone),
                'type': this.type
            };
            axios.post('/send-link/' + this.hashId, data)
                .then(response => {
                    const success = response.data && response.data.status && response.data.status === 'success';
                    let sent = false;
                    if (success) {
                        sent = response.data.emailSent || response.data.smsSent;
                        if (sent) {
                            PNotify.success('Ссылка была отправлена');
                        }
                    }
                    if (!success || !sent) {
                        PNotify.info('Не удалось отправить уведомление');
                        console.log(response);
                    }
                })
                .catch(error => {
                    PNotify.error('Не удалось отправить уведомление');
                })
        },
        osagoCheckStatus() {
            axios.post('/osago/get-info', {
                'orderProcessingId': this.hashId
            })
                .then(response => {
                    console.log(response);
                    if (response.data.data) {
                        this.osagoCheckedStatus = response.data.data.status === '400' || response.data.data.status === '1000';
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        crossCheckStatus() {
            axios.post('/cross/get-info', {
                'orderProcessingId': this.hashId
            })
                .then(response => {
                    console.log(response);
                    if (response.data.data) {
                        this.checkedStatus = response.data.data.status === '400' || response.data.data.status === '1000';
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        checkStatus() {
            axios.post('/cross/mini-casco/get-info', {
                'orderProcessingId': this.hashId
            })
                .then(response => {
                    if (response.data.data) {
                        this.checkedStatus = response.data.data.status === 'payed' || response.data.data.status === 'success';
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        unmaskPhone(phone) {
            return phone ? phone.match(/[0-9]+/g, '').join('') : phone;
        },
        goToFirstError(approveForm = false) {
            this.$vuetify.goTo( approveForm ? '.approve-form .error--text' : '.error--text', {
                duration: 600,
                offset: 450,
                easing: 'easeInCubic',
            });
        },

        // Ниже всё то, что необходимо для кросс-продуктов

        selectCrossId(id) {
            if (this.selectedCrossId === id) {
                this.selectedCrossId = null;
                return;
            }
            this.selectedCrossId = id;
        },

        getImageUrl(img) {
            return window.location.origin + '/' + img;
        },

        userSelectCrossProduct() {
            if (this.isConfirmBtnLoading) return;
            this.isConfirmBtnLoading = true;
            axios.get(`/get-error-manage-cross/${this.hashId}`, {
                params: {
                    selectedCrossId: this.selectedCrossId,
                }
            }).then(() => {
                let paymentUrl = `${window.location.origin}/manage-cross/${this.hashId}?selectedCrossId=${this.selectedCrossId}`;

                const paymentWindow = window.open(paymentUrl, '_self');
                const timer = setInterval(function() {
                    if (paymentWindow && paymentWindow.closed) {
                        clearInterval(timer);
                        this.isConfirmBtnLoading = false;
                    }
                }, 1000);
            }).catch(error => {
                console.log(error.response);
            }).finally(() => {
                this.isConfirmBtnLoading = false;
            });
        },

        refreshLink() {
            const that = this
            axios.get(`/cross/mini-casco/payment/${this.uuid}`)
                .then(response => {
                    this.$nextTick(function() {
                        that.crossLink = response.data.link
                    });
                    PNotify.success('Ссылка обновлена')
                })
                .catch(error => {
                    PNotify.error(error.response.data.error)
                })
        }
    },
    computed: {
        // Ниже всё то, что необходимо для кросс-продуктов

        isOsagoCopyButtonDisabled() {
            if (!this.isOsagoCrossOneLink) {
                if (this.crossRequiredPayment) {
                    if (this.crossPayed || this.checkedStatus) {
                        if (this.osagoPayed || this.osagoCheckedStatus) {
                            return true;
                        }
                        return false;
                    }
                    return true;
                }
            }

            if (this.osagoPayed || this.osagoCheckedStatus) {
                return true;
            }
            return false;
            /*if (this.crossRequired) {
                return true;
            }
            return false;*/
            /*return !this.crossPayed && !this.checkedStatus;*/
        },

        isCrossCopyButtonDisabled() {
            return this.crossPayed == true || this.checkedStatus;
        },

        isOsagoPayButtonDisabled() {
            if (!this.isOsagoCrossOneLink) {
                if (this.crossRequiredPayment) {
                    if (this.crossPayed || this.checkedStatus) {
                        if (this.osagoPayed || this.osagoCheckedStatus) {
                            return true;
                        }
                        return false;
                    }
                    return true;
                }
            }

            if (this.osagoPayed || this.osagoCheckedStatus) {
                return true;
            }
            return false;

            /*if (this.crossRequired) {
                return true;
            }
            return false;*/
            /*return !this.crossPayed && !this.checkedStatus;*/
        },

        isCrossPayButtonDisabled() {
            return this.crossPayed == true || this.checkedStatus;
        },

        isOsagoSendLinkDisabled() {
            if (!this.isOsagoCrossOneLink) {
                if (this.crossRequiredPayment) {
                    if (this.crossPayed || this.checkedStatus) {
                        if (this.osagoPayed || this.osagoCheckedStatus) {
                            return true;
                        }
                        return false;
                    }
                    return true;
                }
            }

            if (this.osagoPayed || this.osagoCheckedStatus) {
                return true;
            }
            return false;
            /*if (this.crossRequired) {
                return true;
            }
            return false;*/
        },

        isCrossSendLinkDisabled() {
            return this.crossPayed == true || this.checkedStatus;
        },

        filteredInfo() {
            if (this.crossSelected) {
                const info = this.crossSelected.product.info;
                return Object.values(info).filter(item => item.title);
            }
        }
    }
}
</script>

<style scoped>

/deep/ h1 {
    font-size: 60px;
    font-family: 'SFProBold'
}

/deep/ h2 {
    font-size: 36px;
    font-family: 'SFProBold'
}

/deep/ h3 {
    font-size: 20px;
    font-family: 'SFProBold'
}

.cross-header {
    max-width: 1200px;
    padding-top: 95px;
    margin-bottom: 40px;
}

.cross-header__link {
    font-size: 18px;
    border-bottom: 1px solid #00ba57;

    margin-bottom: 55px;
    display: inline-block;

    text-decoration: none;
}

.cross-header__title {
    line-height: 1.1;
    color: #000000;
}

.cross-main {
    max-width: 1200px;
}

.cross-main__title {
    margin-bottom: 40px;
}

.cross-main__subtitle {
    margin-bottom: 21px;
}

.cross-main__error {
    font-size: 16px;
    color: #D0343D;
}

.cross-main__second-error {
    background-color: #cd4b52;
    color: #fff;
    border-radius: 16px;
    padding: 10px 20px;
}

.cross-main__success {
    font-size: 16px;
    color: #00BA57;
}

.cross-main__checks {
    gap: 40px;
}

.submit-button {
    color: #ffffff;
    font-size: 18px;
    text-transform: none;

    height: 56px;
    width: 229px;
    background-color: #00ba57 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 62px;
    border-color: transparent;
    border-style: solid;
}

.check-button {
    color: #000000;
    font-size: 18px;
    font-family: 'SFProBold';
    text-transform: none;

    height: 56px;
    width: 229px;
    background-color: #ffffff !important;
    box-shadow: none !important;
    margin: 0;

    border-radius: 62px;
    border: 1px solid #C7C7C7;
}

.send-button {
    color: #ffffff;
    font-size: 18px;
    font-family: 'SFProBold';
    text-transform: none;

    height: 56px;
    width: 229px;
    background-color: #000000 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 62px;
    border-color: transparent;
    border-style: solid;
}

.url-wrapper {
    gap: 20px;
}

.url {
    background: #E8E8E8;
    padding: 20px;
}

.url__text {
    font-family: 'SFPro';
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    text-align: left;
    color: #000000;
    user-select: none;
}

.url__copy {
    height: auto;
    margin: 0;
}

.v-btn--icon {
    width: auto;
}

.cost-wrapper {
    gap: 10px;
}

.data-logo {
    width: 226px;
}

.data-logos {
    width: 160px;
}

.data-title {
    font-size: 16px;
    font-weight: 400;
    color: #828282;
}

.data-param {
    font-size: 28px;
    font-family: 'SfProBold';
    display: block;
}

.data-risks {
    font-size: 16px;
}

.nowrap-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.icon-check {
    color: #00BA57;
}

.text-input {
    width: 95%;
}

.button {
    margin-top: auto;
    margin-bottom: 20px;
}

.data-cross-param {
    display: block;
    font-size: 16px;
    font-family: 'SFProBold', 'SFPro', 'sans-serif';
}

.data-cross-title {
    border-bottom: 1px solid #E8E8E8;
    font-size: 12px;
    font-weight: 400;
    color: #828282;
    font-family: 'SFUIDisplay', 'SFPro', 'sans-serif';
}

.logos {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.text-center {
    text-align: center;
}

.green-mark {
    position: relative;
}

.green-mark::before {
    content: url(/svg/check-green.svg);
    position: absolute;
    left: -14px;
    width: 14px;
}

.refresh-link {
    flex-grow: 0;
    text-decoration: underline;
}

.pay-and-refresh {
    flex-direction: row;
    display: flex;
    align-items: center;
    margin-bottom: 21px;
    justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/ManageCrossLink.vue